import {getSectionCookie} from "./section-cookie";

export default function searchFormUrl() {
    if(getSectionCookie() === 'she') {
        document.querySelector('.search-popup__form input[name="cat"]').value = 'ona';
    } else {
        document.querySelector('.search-popup__form input[name="cat"]').value = 'on';
    }
}

